var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { Icon, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

var Fieldset = (_temp = _class = function (_Component) {
  _inherits(Fieldset, _Component);

  function Fieldset(props) {
    _classCallCheck(this, Fieldset);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      collapsed: props.initialCollapsed
    };

    _this.handleCollapse = _this.handleCollapse.bind(_this);
    return _this;
  }

  Fieldset.prototype.handleCollapse = function handleCollapse() {
    this.setState(function (prevState) {
      return {
        collapsed: !prevState.collapsed
      };
    });
  };

  Fieldset.prototype.render = function render() {
    var _props = this.props,
        label = _props.label,
        collapsible = _props.collapsible;
    var collapsed = this.state.collapsed;

    return React.createElement(
      "fieldset",
      { className: "dt-fieldset" },
      React.createElement(
        "legend",
        { onClick: collapsible && this.handleCollapse || null },
        collapsible && (collapsed ? React.createElement(Icon, { icon: IconNames.CHEVRON_DOWN }) : React.createElement(Icon, { icon: IconNames.CHEVRON_UP })),
        label
      ),
      !collapsed && React.createElement(
        "div",
        { className: "dt-fieldset-content" },
        this.props.children
      )
    );
  };

  return Fieldset;
}(Component), _class.defaultProps = {
  initialCollapsed: false,
  collapsible: false
}, _temp);
Fieldset.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If set, render collapsed fieldset
   */
  initialCollapsed: PropTypes.bool,

  /**
   * If set, enable collapse/uncollapse of fieldset
   */
  collapsible: PropTypes.bool,

  /**
   * Fieldset label
   */
  label: PropTypes.string
} : {};


export default Fieldset;